import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";

// YENİ: Firebase Firestore fonksiyonları ve db instance'ı import edildi
import { db } from "../../../firebase"; // DİKKAT: Bu dosya yolunu kendi projenize göre düzenleyin!
import { doc, getDoc, setDoc } from "firebase/firestore";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
// import axios from "axios"; // KALDIRILDI: Artık axios'a gerek yok
import "jspdf-autotable";

import {
  getProduct as onGetProduct,
  addProduct as onAddProduct,
  updateProduct as onUpdateProduct,
  deleteProduct as onDeleteProduct,
} from "store/contacts/actions";
import { isEmpty } from "lodash";

// redux
import { useSelector, useDispatch } from "react-redux";

// KALDIRILDI: AI Prompt API konfigürasyonu artık Firebase üzerinden yönetilecek
// const AI_API_BASE = process.env.REACT_APP_AI_API_URL || "http://78.135.106.146:9298";
// const ADMIN_TOKEN = process.env.REACT_APP_ADMIN_TOKEN || "";

/** Varsayılan şablon (Back-end’deki DEFAULT ile eşleşir) */
const DEFAULT_MR_BEE_PROMPT = `
Sen Mr. Bee'sin. Destekleyici, motive edici ve öğretici bir İngilizce sınav koçusun. Kullanıcının sınav performansını değerlendirip kişisel geri bildirim yazıyorsun.

İşte kullanıcının sınav sonuçları:
Doğru Sayısı:
Sınav Süresi:
Geçen Süre:
Başarı Oranı:
Seviye:
Yapı & Kelime Beceri yüzdesi:
Anlam/Bağlam Odaklı Beceri yüzdesi:
Çeviri Beceri yüzdesi:

Şu yapıda bir değerlendirme yaz:

Güçlü Yönler: Kullanıcının iyi olduğu beceri yüzdesi %70 ve %89 arası olanlar ile ve kullanıcının çok iyi olduğu beceri yüzdesi %90 ve üzeri olan becerilerdir. Önce bu alanların neler olduğunu belirt. Beceri yüzdesi iyi olan kullanıcıların puanlarını yukarı taşıması, çok iyi olanlarının ise mevcut beceri kapasitelerini koruması hedeflenmelidir. Bunun için bu kapsama giren kullanıcılara iyi ve çok iyi oldukları beceri tiplerine özel olarak dil bilgisi çalışma, okuma, test çözümü, kelime çalışması gibi konularda profesyonel, akademik ve pratik çalışma önerilerinde bulun. Becerilerini daha üst seviyeye taşımalarının mümkün olduğu önünde motive et.

Geliştirmesi gereken alanlar: Kullanıcının beceri yüzdesi %0-49 olduğu zayıf beceriler ile kullanıcının orta seviyede olduğu %50-%69 olan becerilerdir. Önce bu alanların ne olduğunu belirt. Zayıf beceri alanları için kullanıcının nasıl bir çalışma planı izlemesi gerektiği, hangi konulara yoğunlaşması gerektiği gibi hususlarda tavsiyelerde bulun. Aynı şekilde alan becerisi orta seviyede olanlar için de puanlarını %70 üzerine nasıl taşıyabileceklerine yönelik dil bilgisi çalışma, okuma, test çözümü, kelime çalışması gibi konularda profesyonel, akademik ve pratik çalışma önerilerinde bulun.

Süre Yönetimi: Kullanıcının sınavı bitirme süresini ve belirlenen sınav süresini karşılaştır. Gerçekleşen sınav süresinin belirlenen süreye göre aşağıda, yakın veya üzerinde olmasına bağlı olarak önce durumu belirt; ardından süre yönetimine katkı sağlayacak tavsiyeler ver. Sınav süresi değerlendirmesini sınav sonucuyla birlikte ele al, aralarındaki bağlantıdan tahmini bir çıkarım yap.

Son İfadeler: Pozitif ve motive edici bir kapanış cümlesi kur. Ayrıca TestBee uygulamasının düzenli kullanımının başarıya katkı sağlayacağını uygun bir dille belirt. Metni açık, anlaşılır, kısa paragraflar hâlinde yaz.

Yorum Şekli: Toplam 4 paragraf ve 180–250 kelime arası. Yorum yalnızca İngilizce eğitimi ve sınav sonucuna odaklı olsun. Tüm yorum boyunca destekleyici, moral verici, profesyonel, nazik ve akademik bir üslup kullan; yargılayıcı veya suçlayıcı ifadeler kullanma.

ÇIKTI DİLİ: TÜRKÇE.
`.trim();

// YENİ: Firestore doküman yolları (Python koduyla aynı)
const PROMPT_COLL = "config";
const PROMPT_DOC = "mr_bee_prompt";

const ContactsList = props => {
  const tableRef = useRef(null);
  document.title = "Yapay Zeka | Bee Admin PANELI";
  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getSubCategoryID, setSubCategoryID] = useState();

  /** ============ PROMPT STATE ============ */
  const [promptModal, setPromptModal] = useState(false);
  const [promptText, setPromptText] = useState("");
  const [promptSource, setPromptSource] = useState("");
  const [promptLoading, setPromptLoading] = useState(false);
  const [promptSaving, setPromptSaving] = useState(false);

  const validation = useFormik({
    // ... validation (değişiklik yok)
    enableReinitialize: true,
    initialValues: {
      title: (contactEdit && contactEdit.Question_SubCategory_Sub_Text) || "",
      sort: (contactEdit && contactEdit.Sort) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().min(3, "En az 3 karakter giriniz").required("Başlığı Giriniz"),
      sort: Yup.number().typeError("Sıralama sayı olmalıdır").nullable(true),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateUser = {
          ID: contactEdit.ID,
          IsActive: getIsActive,
          Sort: values.sort,
          Question_SubCategory_ID: getSubCategoryID,
          Question_SubCategory_Sub_Text: values.title,
        };
        dispatch(onUpdateProduct(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          IsActive: getIsActive,
          Sort: values.sort,
          Question_SubCategory_ID: getSubCategoryID,
          Question_SubCategory_Sub_Text: values.title,
        };
        dispatch(onAddProduct(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.products,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getSubCategory, setSubCategory] = useState([]);
  const [getIsActive, setIsActive] = useState(false);

  const columns = useMemo(() => [
    // ... columns (değişiklik yok)
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        Header: "Adı",
        accessor: "Question_SubCategory_Sub_Text",
        filterable: true,
        Cell: cellProps => <NameSurname {...cellProps} />,
      },
      {
        Header: "Alt Kategori Adı",
        accessor: "Question_SubCategory.Question_SubCategory_Title",
        filterable: true,
        Cell: cellProps => <NameSurname {...cellProps} />,
      },
      {
        Header: "Sıralama",
        accessor: "Sort",
        filterable: true,
        Cell: cellProps => <NameSurname {...cellProps} />,
      },
      {
        Header: "Aktif Mi?",
        accessor: "IsActive",
        filterable: true,
        Cell: cellProps => <Status {...cellProps} />,
      },
      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  // DEĞİŞTİ: Bu fonksiyon artık kullanılmıyor, silebilirsiniz veya bırakabilirsiniz.
  // Projenin başka yerinde kullanılıyorsa kalsın.
  const _getAuthData = async () => {
    // await axios ...
  };
  
  // ... useEffects (değişiklik yok)
  useEffect(() => {
    // _getAuthData();
    if (users && !users.length) {
      dispatch(onGetProduct());
      setIsEdit(false);
    }
  }, [dispatch, users]);
  useEffect(() => { setContact(users); }, [users]);
  useEffect(() => { if (!isEmpty(users) && !!isEdit) { setContact(users); } }, [users]);
  
  const toggle = () => setModal(!modal);
  const handleUserClick = arg => {
    const user = arg;
    setEditContact(user);
    setSubCategoryID(user.Question_SubCategory_ID);
    setIsActive(user.IsActive);
    setIsEdit(true);
    toggle();
  };
  
  const node = useRef();
  const onPaginationPageChange = page => {
    if ( node && node.current && node.current.props && node.current.props.pagination && node.current.props.pagination.options) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteProduct(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };
  
  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };
  const _setChoiceSubCategory = arg => {
    setSubCategoryID(arg.target.value);
  };

  /** ================= DEĞİŞTİ: PROMPT HANDLERS (Firebase ile) ================= */
  const openPromptModal = async () => {
    setPromptModal(true);
    setPromptLoading(true);
    setPromptSource("");
    try {
      const docRef = doc(db, PROMPT_COLL, PROMPT_DOC);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setPromptText(data.system_prompt || "");
        setPromptSource("firestore");
      } else {
        console.warn("Firestore'da prompt dokümanı bulunamadı. Varsayılan kullanılıyor.");
        setPromptText(DEFAULT_MR_BEE_PROMPT);
        setPromptSource("default");
      }
    } catch (e) {
      console.error("Firestore'dan prompt okunurken hata oluştu:", e);
      window.alert("Prompt yüklenemedi. Varsayılan şablon dolduruldu.");
      setPromptText(DEFAULT_MR_BEE_PROMPT);
      setPromptSource("default (hata)");
    } finally {
      setPromptLoading(false);
    }
  };

  const savePrompt = async () => {
    if (!promptText?.trim()) {
      window.alert("Prompt boş olamaz.");
      return;
    }
    setPromptSaving(true);
    try {
      const docRef = doc(db, PROMPT_COLL, PROMPT_DOC);
      const payload = {
        system_prompt: promptText.trim(),
        updated_at: new Date().toISOString(),
        updated_by: "admin_panel",
      };
      await setDoc(docRef, payload, { merge: true });
      window.alert("Mr. Bee promptu başarıyla Firestore'a kaydedildi.");
      setPromptModal(false);
    } catch (e) {
      console.error("Firestore'a kayıt sırasında hata oluştu:", e);
      window.alert(`Kayıt sırasında hata oluştu: ${e.message}`);
    } finally {
      setPromptSaving(false);
    }
  };

  const fillDefaultPrompt = () => {
    setPromptText(DEFAULT_MR_BEE_PROMPT);
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Bee Yapay Zeka" />
          <Row className="mb-3">
            <Col lg="12">
              {/* ---- DEĞİŞTİ: Prompt Yönetimi Kartı ---- */}
              <Card>
                <CardBody className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="mb-1">Mr. Bee Yapay Zeka Promptu</h5>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      Veri Kaynağı: <b>{promptSource || "—"}</b>
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    {/* YENİ: promptLoading durumunda butonu pasif yapma */}
                    <button type="button" className="btn btn-light" onClick={fillDefaultPrompt} disabled={promptLoading}>
                      Varsayılanı Doldur
                    </button>
                    <button type="button" className="btn btn-primary" onClick={openPromptModal}>
                      Promptu Düzenle
                    </button>
                  </div>
                </CardBody>
              </Card>

              {/* ---- Liste Kartı (değişiklik yok) ---- */}
           
            </Col>
          </Row>
        </Container>
      </div>

      {/* DEĞİŞTİ: PROMPT DÜZENLE Modalı */}
      <Modal isOpen={promptModal} toggle={() => setPromptModal(false)} size="lg">
        <ModalHeader toggle={() => setPromptModal(false)} tag="h4">
          Mr. Bee Promptu Düzenle (Firestore)
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label className="form-label">Sistem Promptu</Label>
            <Input
              type="textarea"
              rows="16"
              value={promptText}
              onChange={e => setPromptText(e.target.value)}
              placeholder="Mr. Bee sistem promptunu buraya yazın…"
              disabled={promptLoading}
            />
          </div>
          <div className="d-flex justify-content-between">
            <button type="button" className="btn btn-outline-secondary" onClick={fillDefaultPrompt} disabled={promptLoading || promptSaving}>
              Varsayılan Şablonla Doldur
            </button>
            <div className="d-flex gap-2">
              <button type="button" className="btn btn-light" onClick={() => setPromptModal(false)} disabled={promptSaving}>
                İptal
              </button>
              <button type="button" className="btn btn-primary" onClick={savePrompt} disabled={promptSaving || promptLoading}>
                {promptSaving ? "Kaydediliyor..." : "Değişiklikleri Kaydet"}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);